import styled from '@emotion/styled';
import { Spinner } from '@galaxy-react/core';

type Props = {
  label?: string;
};

const SpinnerLayout = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  height: '100%',
  width: '100%',
  flex: 1,
  // fix online styling issue
  textAlign: 'left',
});
const ReportsSpinner = (props: Props) => {
  const { label } = props;
  return (
    <SpinnerLayout>
      <Spinner label={label ?? 'Loading your data, just a moment…'} labelPosition="below"></Spinner>
    </SpinnerLayout>
  );
};

export default ReportsSpinner;
